export enum Environment {
  PROD = 'production',
  DEV = 'development',
  STAG = 'staging',
}

export enum Site {
  au = 'au',
  nz = 'nz',
}

export enum Country {
  NZ = 'New Zealand',
  AU = 'Australia',
  TH = 'Thailand',
  HK = 'Hong Kong',
  ID = 'Indonesia',
  SG = 'Singapore',
  MY = 'Malaysia',
  PH = 'Philippines',
}

export const countries = {
  NZ: Country.NZ,
  AU: Country.AU,
};

export enum CSPhoneNumber {
  NZ = '0508 733 569',
  AU = '1300 658 700',
}

export enum UtagEnv {
  DEV = 'dev',
  QA = 'qa',
  PROD = 'prod',
}

export enum Locale {
  AU = 'AU',
  NZ = 'NZ',
}

export interface EnvConfig {
  ENV: Environment;
  LOCALE: Locale;
}

export const demonyms = {
  NZ: 'New Zealander',
  AU: 'Australian',
};
